export default "__VITE_ASSET__BG6THXY3__"